/*
 * EnvAuthenticator Messages
 *
 * This contains all the text for the EnvAuthenticator scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.EnvAuthenticator";

export default defineMessages(scope, {
  header: "an Authenticator App",
});
